import { msg } from "@lingui/core/macro";

/** Label constants for Computer network UI (section lives under Security). */
export const COMPUTER_NETWORK_SECTION_LABEL = msg`Network`;
export const COMPUTER_ALLOWED_DOMAINS_LABEL = msg`Allowed domains`;
